import { render, staticRenderFns } from "./HomeReminders.vue?vue&type=template&id=65ab6d3e"
import script from "./HomeReminders.vue?vue&type=script&lang=js"
export * from "./HomeReminders.vue?vue&type=script&lang=js"
import style0 from "./HomeReminders.vue?vue&type=style&index=0&id=65ab6d3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports